import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { ManagementVoyageModel } from '@data-layer/models/management';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { enumVoyageStatusTab } from '../../enums';
import { VoyageTabsCountModel } from '../../models';

@Component({
  selector: 'view-voyages-list',
  templateUrl: './view-voyages-list.component.html',
  styleUrls: ['./view-voyages-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ViewVoyagesListComponent {
  @Input() public showHeader: boolean = true;
  @Input() public showVoyage: boolean = true;
  @Input() public voyages$: Observable<ManagementVoyageModel[]>;
  @Input() public isLoading: boolean = false;
  @Input() public total: number;
  @Input() public limit: number;
  @Input() public totalRows: number;
  @Input() public page: number = 1;
  @Input() public currentSelectedTab: enumVoyageStatusTab;
  @Input() public tabsCount: VoyageTabsCountModel;
  @Output() public pageChanged: EventEmitter<number> = new EventEmitter<number>();
  @Output() public limitChanged: EventEmitter<number> = new EventEmitter<number>();
  @Output() public selectTab: EventEmitter<enumVoyageStatusTab> = new EventEmitter<enumVoyageStatusTab>();

  public tableId: string = 'voyages-list';
  public enumVoyageStatusTab: typeof enumVoyageStatusTab = enumVoyageStatusTab;

  constructor(private router: Router) {}

  public openVoyage(id: number): void {
    this.router.navigate(['/voyages-management', id]);
  }
}
